var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaperclipSolid = function SvgPaperclipSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "paperclip-solid",
    d: "M1.352,14.566a4.9,4.9,0,0,1,.043-6.8L7.95,1.062a3.5,3.5,0,0,1,5.021,0,3.638,3.638,0,0,1,0,5.071L7.257,11.972a2.332,2.332,0,0,1-3.374-.031A2.422,2.422,0,0,1,3.928,8.6L8.42,4.01A.5.5,0,0,1,9.127,4l.714.7a.5.5,0,0,1,.008.707L5.357,10a.423.423,0,0,0-.02.572.333.333,0,0,0,.49.005l5.714-5.839a1.637,1.637,0,0,0,0-2.275,1.5,1.5,0,0,0-2.161,0l-6.555,6.7a2.894,2.894,0,0,0-.037,4.01,2.665,2.665,0,0,0,3.846.009l5.377-5.5a.5.5,0,0,1,.707-.008l.715.7a.5.5,0,0,1,.008.707l-5.377,5.5a4.663,4.663,0,0,1-6.712-.015Z",
    transform: "translate(0 0.001)",
    fill: "#3c3e69"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperclipSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paperclip-solid.85b0f895.svg";
export { ForwardRef as ReactComponent };